import 'core-js/actual/iterator'
import { vec3 } from "./VectorMath.ts"

function makeBoneVertices(): {
  positions: Float32Array
  normals: Float32Array
} {
  const angleCount = 4
  const height = 1
  const equator = 5 / 32
  const radius = 1 / 8

  let positionArray: vec3[] = []
  let normalArray: vec3[] = []

  const tip = new vec3(0, height, 0)

  for (let i = 0; i < angleCount; ++i) {
    const c0 = Math.cos(2 * Math.PI * i / angleCount)
    const s0 = Math.sin(2 * Math.PI * i / angleCount)
    const c1 = Math.cos(2 * Math.PI * (i + 1) / angleCount)
    const s1 = Math.sin(2 * Math.PI * (i + 1) / angleCount)

    const p0 = vec3.zero
    const p1 = new vec3(c0 * radius, equator, s0 * radius)
    const p2 = new vec3(c1 * radius, equator, s1 * radius)
    const p3 = tip

    const nLower = p1.minus(p0).cross(p2.minus(p0)).normalized
    const nUpper = p2.minus(p3).cross(p1.minus(p3)).normalized

    positionArray.push(p0, p1, p2, p3, p2, p1)
    normalArray.push(nLower, nLower, nLower, nUpper, nUpper, nUpper)
  }

  const positions = Float32Array.from(positionArray.values().flatMap(v => [...v]))
  const normals = Float32Array.from(normalArray.values().flatMap(n => [...n]))

  return { positions, normals }
}

export const BoneMesh = makeBoneVertices()
